/* Potato & Co. purchase guard
 * 1. The sticky mobile Add button skipped required photo and name fields. On products that
 *    need details it now takes the shopper to the fields instead of adding to cart.
 * 2. Photo products with no photo are flagged in the cart and checkout is held until fixed.
 *    Name-only products are not held, because their name fields are optional.
 * 3. Chat is hidden while the sticky bar is showing so it can't cover purchase controls.
 */
(function () {
  'use strict';
  if (window.potatoGuardLoaded) return;
  window.potatoGuardLoaded = true;

  var cfg = window.potatoGuard || {};
  var incomplete = [];

  function needsPhoto(t) { return /custom pet photo|personalized ugly/i.test(t || ''); }

  function missingDetails(item) {
    if (!needsPhoto(item.product_title || item.title)) return false;
    var props = item.properties || {};
    return !Object.keys(props).some(function (k) {
      return k.charAt(0) !== '_' && /upload|photo|image/i.test(k) && String(props[k]).trim() !== '';
    });
  }

  function renderNotice() {
    document.querySelectorAll('.pc-cart-notice').forEach(function (n) { n.remove(); });
    var hide = incomplete.length > 0;
    document.querySelectorAll('.cart__checkout shopify-accelerated-checkout-cart, .cart__checkout .additional-checkout-buttons, .drawer__footer shopify-accelerated-checkout-cart').forEach(function (e) {
      e.style.display = hide ? 'none' : '';
    });
    if (!hide) return;
    document.querySelectorAll('.js-cart-total').forEach(function (t) {
      var box = document.createElement('div');
      box.className = 'pc-cart-notice';
      box.setAttribute('role', 'alert');
      var html = '<strong>We still need your pet photo.</strong><ul>';
      incomplete.forEach(function (i) {
        html += '<li><a href="' + i.url.split('?')[0] + '?variant=' + i.variant_id + '">' + i.product_title + '</a></li>';
      });
      html += '</ul><span>Open the item, add your photo, add it to your cart again, then remove this one.</span>';
      box.innerHTML = html;
      t.parentNode.insertBefore(box, t);
    });
  }

  function refreshCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
      incomplete = c.items.filter(missingDetails);
      renderNotice();
    }).catch(function () {});
  }

  var origFetch = window.fetch;
  window.fetch = function (url) {
    var p = origFetch.apply(this, arguments);
    var u = typeof url === 'string' ? url : (url && url.url) || '';
    if (/\/cart\/(add|change|update|clear)/.test(u)) {
      p.then(function () { setTimeout(refreshCart, 500); });
    }
    return p;
  };

  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[name="checkout"], a[href="/checkout"], a[href*="/checkouts"]');
    if (t && incomplete.length) {
      e.preventDefault();
      e.stopImmediatePropagation();
      renderNotice();
      var scope = t.closest('#ecxCartDrawer') || document.getElementById('mainCart') || document;
      var n = scope.querySelector('.pc-cart-notice');
      if (n) n.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }
  }, true);

  /* Sticky bar */
  function firstMissing() {
    var fields = [].slice.call(document.querySelectorAll('input[required], textarea[required], select[required]')).filter(function (f) {
      return f.offsetParent !== null && !f.closest('.product__sticky-info') && !f.closest('#cartDrawer') && !String(f.value).trim();
    });
    return fields[0] || null;
  }

  function uploadBlock() {
    var b = document.querySelector('[data-ph_storename]');
    return b && b.offsetHeight > 10 ? b : null;
  }

  function initSticky() {
    var sticky = document.querySelector('.product__sticky-info');
    if (!sticky) return;
    var btn = sticky.querySelector('.js-product-form-submit-btn');
    if (btn && cfg.custom) {
      var label = btn.querySelector('.js-product-form-submit-btn-text');
      if (label && !btn.disabled) label.textContent = 'Personalize';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        var field = firstMissing();
        var target = uploadBlock() || field || document.querySelector('.product-form__buttons');
        if (target) target.scrollIntoView({ block: 'center', behavior: 'smooth' });
        if (field && target === field) setTimeout(function () { field.focus({ preventScroll: true }); }, 400);
      }, true);
    }
    var sync = function () {
      var c = getComputedStyle(sticky);
      var on = c.display !== 'none' && parseFloat(c.opacity) > 0.5 && sticky.offsetParent !== null && window.scrollY > 200;
      document.documentElement.classList.toggle('potato-sticky-on', on);
    };
    new MutationObserver(sync).observe(sticky, { attributes: true, attributeFilter: ['class', 'style'] });
    window.addEventListener('scroll', sync, { passive: true });
    sync();
  }

  function init() {
    refreshCart();
    initSticky();
    var drawer = document.getElementById('ecxCartDrawer');
    if (drawer) new MutationObserver(function () { if (incomplete.length && !drawer.querySelector('.pc-cart-notice')) renderNotice(); }).observe(drawer, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
